// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
import gsap from 'gsap'
import { Breakpoints } from '../utils/breakpoints'

export default class InfographicOverlayController extends AdvancedController {

  static targets = [
    "overlayWrapper",
    "overlays",
    "overlay",
    "imageWrapper",
    "tooltip"
  ];

  static values = {
    hotspots: String,
    activeIndex: {
      type: Number,
      default: -1
    }
  }

  connect() {
    super.connect(...arguments)

    this.hotspots = JSON.parse(atob(this.hotspotsValue));

    this.ids = this.hotspots.map(item => item.id)
    for (const id of this.ids) {
      document.getElementById(id).addEventListener('click', this.onHotspotClick.bind(this))
      document.getElementById(id).addEventListener('mouseenter', this.onMouseEnter.bind(this))
      document.getElementById(id).addEventListener('mousemove', this.onMouseMove.bind(this))
      document.getElementById(id).addEventListener('mouseleave', this.onMouseLeave.bind(this))
    }

    window.addEventListener('scroll', this.updateTooltipPosition.bind(this))

    this.forceHeight();

    this.overlaysTarget.style.display = "flex"
    this.isActive = false;

    this.breakpoints = new Breakpoints()

    this.isTouchDevice = false;
    window.addEventListener('touchstart', () => {
      this.isTouchDevice = true;
    });
  }

  async onHotspotClick(e) {
    const clickedId = e.currentTarget.getAttribute('id')
    if (this.ids.includes(clickedId)) {

      this.resetCurrentSegment();
      this.currentTarget = e.currentTarget
      this.highlightCurrentSegment()

      this.forceHeight();
      const index = this.ids.indexOf(clickedId)

      if (!this.isActive) {
        this.setActive();
        this.shrinkGraphic();
      } else {
        await this.hideCurrentActive();
      }
      await this.showOverlay(index)
    }
  }

  onMouseEnter(e) {
    if (this.isTouchDevice) return;
    this.tooltipTarget.style.display = "block"
    this.tooltipTarget.style.position = "absolute"

    const enteredId = e.currentTarget.getAttribute('id')
    const index = this.ids.indexOf(enteredId)

    this.tooltipTarget.innerHTML = this.hotspots[index].tooltip

    this.lastMouseY = e.clientY;
    this.updateTooltipPosition(e)
  }

  onMouseMove(e) {
    if (this.isTouchDevice) return;
    this.lastMouseY = e.clientY;
    this.updateTooltipPosition(e)

  }

  onMouseLeave(e) {
    if (this.isTouchDevice) return;
    this.tooltipTarget.style.display = "none"
  }

  updateTooltipPosition(e) {
    const boundingClientRect = this.tooltipTarget.parentElement.getBoundingClientRect();
    this.tooltipTarget.style.top = `${this.lastMouseY - boundingClientRect.top - this.tooltipTarget.offsetHeight - 8}px`
    this.tooltipTarget.style.left = `${e.clientX - this.tooltipTarget.parentElement.offsetLeft - this.tooltipTarget.offsetWidth / 2}px`
  }

  async onClose() {
    this.resetCurrentSegment();
    this.setInactive();
    this.hideOverlay();
    await this.growGraphic();
  }

  setActive() {
    this.isActive = true
    this.element.classList.add('-active')
  }

  setInactive() {
    this.isActive = false
    this.element.classList.remove('-active')
  }

  forceHeight() {
    this.overlayWrapperTarget.style.height = `${this.overlayWrapperTarget.offsetHeight}px`
    this.imageWrapperTarget.style.position = "absolute"
    this.imageWrapperTarget.style.top = "0px"
    this.imageWrapperTarget.style.left = `${this.imageWrapperTarget.offsetLeft}px`
  }

  async shrinkGraphic() {
    return new Promise(onComplete => {
      const isInitialized = this.imageWrapperTarget.getAttribute('data-initialized');
      if (isInitialized != 'yes') {
        this.imageWrapperTarget.setAttribute('data-left', this.imageWrapperTarget.style.left);
        this.imageWrapperTarget.setAttribute('data-width', this.imageWrapperTarget.offsetWidth);
        this.imageWrapperTarget.setAttribute('data-height', this.imageWrapperTarget.offsetHeight);
        this.imageWrapperTarget.setAttribute('data-initialized', 'yes')
      }

      const width = this.breakpoints.breakpointDown('sm') ? '2rem' : '5rem';
      const height = this.breakpoints.breakpointDown('sm') ? '2rem' : '5rem';

      gsap
        .to(this.imageWrapperTarget, { position: "absolute", left: "0px", top: "0px", width, height, onComplete })
    });
  }

  async growGraphic() {
    return new Promise(onComplete => {
      const dataLeft = this.imageWrapperTarget.getAttribute('data-left');
      const dataHeight = this.imageWrapperTarget.getAttribute('data-height');
      const dataWidth = this.imageWrapperTarget.getAttribute('data-width');
      gsap
        .to(this.imageWrapperTarget, { position: "absolute", left: dataLeft, top: "0", width: `${dataWidth}px`, height: `${dataHeight}px`, onComplete })
    });
  }

  async hideCurrentActive() {
    if (this.activeIndex >= 0) {
      this.overlayTargets[this.activeIndex].style.display = "none"
    }
  }

  async showOverlay(index) {
    this.overlayTargets[index].style.display = "block"
    gsap.fromTo(this.overlayTargets[index], { opacity: 0 }, { display: "block", opacity: 1 })
    this.activeIndex = index
  }

  async hideOverlay() {
    gsap.to(this.overlayTargets[this.activeIndex], { display: "none", opacity: 0 })
    this.activeIndex = -1
  }

  highlightCurrentSegment() {
    this.currentTarget.classList.add('-active')
  }

  resetCurrentSegment() {
    if (this.currentTarget) {
      this.currentTarget.classList.remove('-active')
      this.currentTarget = null
    }
  }

}
